import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import {COLORS} from '@/style_vars'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

//TODO: move imports to a cleaner 

import { faFacebook,faWhatsapp,faTelegram, faTiktok, faYoutube, faInstagram, faTumblr, faTwitter, faReddit, faLinkedin, faSnapchat, faPinterest, faBehance, faMedium, faAmazon, faSpotify, faSoundcloud, faAirbnb, faGooglePlay, faAppStore, faGithub,faGitlab } from '@fortawesome/free-brands-svg-icons'
import {faUpload,faGripLinesVertical,faSpinner ,faEllipsisH,faUser,faEnvelope,faChevronUp,faChevronDown,faCheck,faTimes,faSortDown} from '@fortawesome/free-solid-svg-icons'
library.add(faUpload,faGripLinesVertical,faSpinner, faEllipsisH, faUser, faEnvelope,faChevronUp,faChevronDown,faCheck,faTimes,faSortDown)
library.add(faFacebook, faTelegram,faWhatsapp ,faTiktok, faYoutube, faInstagram, faTumblr, faTwitter, faReddit, faLinkedin, faSnapchat, faPinterest, faBehance, faMedium, faAmazon, faSpotify, faSoundcloud, faAirbnb, faGooglePlay, faAppStore, faGithub, faGitlab)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(COLORS)

Vue.use(Buefy,{
  defaultIconPack: 'fas',
  defaultIconComponent: FontAwesomeIcon,
})

Vue.config.productionTip = false

new Vue({
  router,
  store:store,
  render: h => h(App)
}).$mount('#app')

export default Vue